var _typeTofactoryMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ELEMENT } from '../const';
import image from './image';
import button from './button';
import separator from './separator';
import row from './row';
import date from './date';

var typeTofactoryMap = (_typeTofactoryMap = {}, _defineProperty(_typeTofactoryMap, ELEMENT.image, image), _defineProperty(_typeTofactoryMap, ELEMENT.button, button), _defineProperty(_typeTofactoryMap, ELEMENT.row, row), _defineProperty(_typeTofactoryMap, ELEMENT.separator, separator), _defineProperty(_typeTofactoryMap, ELEMENT.date, date), _typeTofactoryMap);

/**
 * Фабрика элементов
 * @param  {Object} element
 * @param  {Object} props
 * @return {Object}
 */
export default (function (element) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!element) {
        return null;
    }

    var factory = typeTofactoryMap[element.type];

    return factory ? factory(element, props) : null;
});